import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Button extends Controller {

    constructor(dom, options) {
        super(dom, "Button");

        Object.assign(this, {
            formlisten: options.formlisten || null,
            uri: options.uri || '',
            confirm: options.confirm || '',
            finallyCallback: options.finallyCallback || null,
            canSendRequestToServer: true
        });
    }
    /*
    * get true uri by server listener key
    */
    _getUriRequest(key) {
        return (key.startsWith('http') || key.startsWith('/')) ? key : `ajax-${key}`;
    }


    /*
    * create server listener from usual button
    */
    serverListener(key) {
        let that = this,
            form = this.domNode,
            isFindForm = false;

        if (this.formlisten) {
            while (form && form != document.body) {
                if (form.tagName.toLowerCase() == "form") {
                    isFindForm = true;
                    break;
                }
                form = form.parentNode;
            }
        }

        function _sendRequestToServer(form) {
            if (!that.canSendRequestToServer)
                return;

            if (form)
                cfJS.removeValidationErrorFromForm(form);

            Engine.postRequest(
                that.uri ? that.uri + "ajax-" + key : that._getUriRequest(key),
                Engine.getPagesFieldsValue(form),
                function (response) {
                    that._enabledServerSend();

                    Engine.parseRequestAnswer(response);

                    //Todo test
                    if (typeof window[that.finallyCallback] === 'function') {
                        window[that.finallyCallback](response, that, form);
                    }
                }
            );
        }

        function _buttonClickEvent(e) {
            if (that.formlisten && isFindForm) {
                if (that.formListener)
                    that.formListener.disconnect();

                //its mean what form valid
                that.formListener = cfJS.addListener(form, "submit", function (e) {
                    if (that.confirm) {
                        let isAccepted = confirm(that.confirm);

                        if (isAccepted) {
                            _sendRequestToServer(form);
                            that._disabledServerSend();
                        }
                    } else {
                        _sendRequestToServer(form);
                        that._disabledServerSend();
                    }

                    e.preventDefault();
                    return false;
                });
            } else {
                _sendRequestToServer();
                that._disabledServerSend();
            }
        }

        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            _buttonClickEvent(e);
        });
    }

    // Privates
    _findForm(startNode) {
        let node = startNode;
        while (node && node !== document.body) {
            if (node.tagName?.toLowerCase() === 'form') return node;
            node = node.parentNode;
        }
        return null;
    }
    /*
    *
    */
    _enabledServerSend() {
        this.canSendRequestToServer = true;
        this.domNode.removeAttribute("wait-answer", "");
    }
    /*
    *
    */
    _disabledServerSend() {
        this.canSendRequestToServer = false;
        this.domNode.setAttribute("wait-answer", "");
    }
    /*
    * call client trigger by listener
    */
    callClientFunction(e, that, key) {
        if (key && typeof key === "function")
            key(e, that);
        else
            window[key](e, that);
    }

    clientListener(key) {
        const that = this;

        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            if (that.confirm) {
                let isAccepted = confirm(that.confirm);

                if (isAccepted) {
                    that.callClientFunction(e, that, key);
                    /*if (key && typeof key==="function")
                        key(e,that);
                    else
                        window[key](e,that);*/
                }
            } else
                that.callClientFunction(e, that, key);

            e.preventDefault();
            return false;
        });
    }
    /*
    * call link event click
    */
    clientLinkListener(url) {
        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            location.href = url;
        });
    }
}

window.Button = Button;